import 'containers/common/Detail.css';
import PropertyArticleList from "containers/property/PropertyArticleList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";




export default class PropertyArticleModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true            
        };
     
       
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    


    renderComponent() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.togglePropertyArticleModal}
                dialogClassName="property-table-modal-wide"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Property Articles</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
              
                    
                    <PropertyArticleList
                        isAuthenticated={this.props.isAuthenticated}
                        controlType="table2"
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        articleid={this.props.articleid}
                        />

                    
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="Edit">
                {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            </div>
        );
    }
}
